import React from "react";
import CustomText from "pages/_components/CustomText/CustomText";
import { string } from "prop-types";

const EcheckState = ({ state, className }) => {
    let classname;

    // TODO: AGREGAR COLORES UX.
    switch (state) {
        case state?.includes("PENDIENTE"):
            classname = "tag-error";
            break;
        case "ACTIVO":
        case "DEPOSITADO":
        case "CUSTODIA":
        case "PRESENTADO":
        case "A LA ORDEN":
            classname = "tag-error";
            break;
        case state?.includes("RECHAZADO"):
        case "NO A LA ORDEN":
            classname = "tag-error";
            break;
        default:
            classname = "tag-error";
            break;
    }

    return <CustomText text={state} textType="TEXT" className={`${classname} ${className} tag`} />;
};

EcheckState.propTypes = {
    state: string.isRequired,
    className: string.isRequired,
};

export default EcheckState;
